import React from 'react';
import { useParams, Link, useHistory } from 'react-router-dom';
import pick from 'lodash/pick';
import { useDispatch } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import IconButton from '@material-ui/core/IconButton';
import ArrowBack from '@material-ui/icons/ArrowBack';
import Main from 'components/templates/Main';
import Api from 'api';
import { showSnackbar } from 'actions';
import PATHS from 'constants/paths';
import EditReview from '../components/Edit';

const ReviewsAddContainer = () => {
  const { id } = useParams();
  const history = useHistory();
  const dispatch = useDispatch();
  const [review, setReview] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(true);
  const [isUpdating, setIsUpdating] = React.useState(false);

  const fetchReview = async () => {
    try {
      const data = await Api.fetchReview(id);

      setReview(data);
      setIsLoading(false);
    } catch (err) {
      history.push(PATHS.reviews.root);
    }
  };

  React.useEffect(() => {
    fetchReview();
  }, []);

  const sendReview = async (data) => {
    try {
      setIsUpdating(true);

      await Api.updateReview(id, pick(data, ['body', 'score', 'year', 'accuracy', 'cleanliness', 'location']));

      dispatch(showSnackbar({
        severity: 'success',
        message: {
          id: 'review.editSuccess',
          defaultMessage: 'The review has been modified',
        },
      }));

      history.push(PATHS.reviews.root);
    } catch (err) {
      dispatch(showSnackbar({
        severity: 'error',
        message: {
          id: 'review.editError',
          defaultMessage: 'The review could not be modified',
        },
      }));

      setIsUpdating(false);
    }
  };

  return (
    <Main title={(
      <div>
        <IconButton
          color="inherit"
          component={Link}
          to={PATHS.reviews.root}
        >
          <ArrowBack />
        </IconButton>
        <FormattedMessage
          id="Edit Review"
          defaultMessage="Edit Review"
        />
      </div>
    )}
    >
      <EditReview
        isLoading={isLoading}
        isUpdating={isUpdating}
        sendReview={sendReview}
        initialValues={review}
      />
    </Main>
  );
};

export default ReviewsAddContainer;
